import { render, staticRenderFns } from "./User-addons.vue?vue&type=template&id=d2c8edb6&scoped=true"
import script from "./User-addons.vue?vue&type=script&lang=js"
export * from "./User-addons.vue?vue&type=script&lang=js"
import style0 from "./User-addons.vue?vue&type=style&index=0&id=d2c8edb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c8edb6",
  null
  
)

export default component.exports